module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9790c70a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/err/404.vue
// module id = 196
// module chunks = 17 18